import { render, staticRenderFns } from "./IconRewardMyPoints.vue?vue&type=template&id=48605722"
import script from "./IconRewardMyPoints.vue?vue&type=script&lang=js"
export * from "./IconRewardMyPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports